export default "__VITE_ASSET__D5JFF0IY__"